import { observer } from 'mobx-react-lite'
import React, { Fragment, useContext, useMemo, useState } from 'react'
import { Fire } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import { currencyFormat } from '../../../../../../../utils/Helper'
import DropdownButton from '../../../../../../FormComponents/DropdownButton'
import AdvertiserMarginColumn from './AdvertiserMarginColumn'
import InfluencerPayoutMarginColumn from './InfluencerPayoutMarginColumn'
import ActionGroupDropdownButton from './MediaActionGroupParts/ActionGroupDropdownButton'
import NonMediaActions from './NonMediaActions'

export default observer(function NonMediaScenarioActionGroup({ actionGroup, campaignScenario }) {
  const { campaign } = useContext(CampaignContext)
  const [dropdownOpen, setDropdownOpen] = useState(true)

  const actions = useMemo(() => campaignScenario.actions.filter(action => action.campaign_scenario_action_group_id === actionGroup.id), [campaignScenario.actions, campaignScenario.actions.length])

  const influencerPrice = useMemo(() => actions.reduce((result, action) => result + action.influencerPrice, 0))
  const advertiserPrice = useMemo(() => actions.reduce((result, action) => result + action.totalAdvertiserPrice, 0))
  const ksaPrice = useMemo(() => actions.reduce((result, action) => result + action.totalKsaPrice, 0))

  return (
    <Fragment>
      <div className={`grid grid-cols-12 ${dropdownOpen && 'border-b-2 border-border-primary dark:border-rb-dark-mode-lighter'}`}>
        <div className="flex items-center justify-between col-span-5 p-2 border-r-2 border-border-primary dark:border-rb-dark-mode-lighter">
          <div className="flex items-center">
            <Fire className="text-white bg-gray-950 dark:bg-rb-dark-mode-lighter" style={{ padding: 2 }} />
            <p className="ml-2 font-bold dark:text-white">Non-media</p>
          </div>
          <div className="flex items-center">
            <ActionGroupDropdownButton actionGroup={actionGroup} campaignScenario={campaignScenario} />
            <DropdownButton dropdownOpen={dropdownOpen} setDropdownOpen={setDropdownOpen} />
          </div>
        </div>
        <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
          <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Inf. Price</p>
          <p className="font-bold dark:text-white">{currencyFormat(influencerPrice.toFixed(2), campaign.currency_symbol)}</p>
        </div>
        <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
          <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">Adv. Price</p>
          <p className="font-bold dark:text-white">{currencyFormat(advertiserPrice.toFixed(2), campaign.currency_symbol)}</p>
        </div>
        <div className="border-r-2 border-border-primary dark:border-rb-dark-mode-lighter p-2">
          <p className="text-rb-lighter-grey dark:text-gray-400 text-xs">KSA Tax</p>
          <p className="font-bold dark:text-white">{currencyFormat(ksaPrice.toFixed(2), campaign.currency_symbol)}</p>
        </div>
        <InfluencerPayoutMarginColumn
          campaignScenario={campaignScenario}
          actionGroup={actionGroup}
          actions={actions}
        />
        <AdvertiserMarginColumn
          campaignScenario={campaignScenario}
          actionGroup={actionGroup}
          actions={actions}
        />
      </div>
      { dropdownOpen && <NonMediaActions actions={actions} campaignScenario={campaignScenario} actionGroup={actionGroup} />}
    </Fragment>
  )
})